<template>
  <div class="order-wrapper payment-wrapper" :class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <PrimaryFilter
        searchText="Search"
        :menuOptions="Menu"
        :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchParameters"
        :preSearchedParams="queryTerms"
        :buttonsList="getTrackButtons"
        @showTripForm="showTripForm"
        @searchByParameter="searchQuery" />
    </portal>
    <div>
      <div class="flex-container page-filter">
        <div class="flex-item">
          <FilterWrapper
            :values="filterParams"
            @openSliderLeft="openSlideleft = !openSlideleft">
          </FilterWrapper>
        </div>
        <div class="flex-item f-right" v-if="!disableAddButton">
          <div class="row">
          <div class="col-md-auto">
            <div class="selectedcount">
              <div>
                <span class="selectedcount-name">Total Trips</span>
              </div>
              <div class="selectedcount-value">
                {{trackMeta.tripCount}}
                <span v-if="currentTransporter.isTrial">
                  {{currentTransporter.max_trip_count}}
                </span>
              </div>
            </div>
          </div>
          <div class="flex-item f-right">
            <div class="selectedcount">
              <div>
                <span class="selectedcount-name">Pings in {{trackMeta.month}}</span>
              </div>
              <div class="selectedcount-value">
                {{trackMeta.pingCount}}
              </div>
            </div>
          </div>
          </div>
        </div>
        <div class="flex-item" v-else>
          <div class="errormsg_block">
            <span class="errormsg_block_text">Free trials have ended. Please contact</span>
            <a href="mailto:support@pando.in" class="errormsg_block_link">support@pando.in</a>
          </div>
        </div>
      </div>
      <div class="slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
        <div class="slideleft_content">
          <div class="content">
            <div class="cardpanel alertoption">
              <Header :headers = "tripHeader"
                :noCheckbox = "true" />
              <div class="emptydiv" v-if="tripList.length === 0">
                <div class="paymentempty"></div>
                <div class="emptytext">Enjoy your day, no trip available!</div>
                <div class="emptytext txtopacity">गाड़ी नहीं पहुंची क्या ?</div>
              </div>
              <div v-else>
                <List
                  v-for = "(trip, index) in tripList"
                  :trip = "trip"
                  :key = "trip._id"
                  :index="index"
                  :sectionHeader = "tripHeader"
                  :selected = "selectedTrip"
                  @showDetails = "showDetails"/>
              </div>
            </div>
          </div>
        </div>
        <div class="slideleft_menu">
          <SecFilter
            :referenceCityList= "referenceCityList"
            :statusList= "statusList"
            :tripTypes = "tripTypes"
            :selectedFilters= "defaultValues"
            @search="search"/>
        </div>
        <div class="sidenavright" :class="{ isOpen: isOpenUpdate }">
          <Details
            @close="isOpenUpdate = false"
            @endTrip="endTrip"
            :selectedTrip="selectedTrip"
            v-if="!showAddForm"/>
            <AddTrip
            :referenceCityList= "referenceCityList"
            v-if="showAddForm"
            @newTripAdd="newTripAdd"
            @close="isOpenUpdate = false"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import debounce from 'debounce';
import { mapGetters } from 'vuex';
import FilterWrapper from '@common/components/FilterWrapper';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import PrimaryFilterTrack from '@/components/common/PrimaryFilterTrack';
import Details from '@/components/common/Details';
import SecFilter from '@common/components/SecFilter';
import {
  tripHeader,
  statusList,
  tripTypes,
  trackButtons,
  searchParameters,
  Menu } from '@/constants/tracking';
import Header from '@common/components/Header';
import List from './List';
import AddTrip from './AddTrip';

export default {
  components: {
    Header,
    List,
    SecFilter,
    FilterWrapper,
    PrimaryFilter,
    PrimaryFilterTrack,
    Details,
    AddTrip,
  },
  data() {
    return {
      tripHeader,
      statusList,
      tripTypes,
      trackButtons,
      searchParameters,
      Menu,
      defaultValues: {},
      selectedTrip: {},
      openSlideleft: false,
      filterParams: {},
      queryTerms: {},
      isOpenUpdate: false,
      showAddForm: false,
      loadCheck: true,
      enableSearchPopup: true,
      searchedParams: {},
    };
  },
  computed: {
    ...mapGetters({
      currentTransporter: 'app/currentTransporter',
      tripFilter: 'tracking/tripFilter',
      tripList: 'tracking/tripList',
      hasEmpty: 'tracking/hasEmpty',
      trackMeta: 'tracking/trackMeta',
      referenceCityList: 'app/cities',
    }),
    selectedCategory() {
      return this.Menu[1];
    },
    disableAddButton() {
      return (this.trackMeta.tripCount && this.currentTransporter.isTrial) ?
        this.trackMeta.tripCount >= this.currentTransporter.max_trip_count : false;
    },
    getTrackButtons() {
      let buttons = this.trackButtons;
      buttons.find(button => button.name === 'Add').disabled = (this.trackMeta.tripCount
        && this.currentTransporter.isTrial) ? this.trackMeta.tripCount >=
        this.currentTransporter.max_trip_count : false;
      buttons = this.trackButtons.filter((button) => {
        return button.permission ? this.$hasPermission(button.permission) : true;
      });
      return buttons;
    },
  },
  created() {
    this.setDefaults();
    this.search(this.defaultValues);
  },
  mounted() {
    document.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    document.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll: debounce(function ondebounceScroll() {
      const d = document.documentElement;
      const offset = d.scrollTop + window.innerHeight;
      const height = d.offsetHeight - 100;
      if (offset >= height && !this.hasEmpty) {
        this.$store.commit('tracking/SET_TRACK_PAGE', this.tripFilter.page + 1);
        this.loadmore();
      }
    }, 100),
    setDefaults() {
      this.defaultValues.status = this.statusList[0];
      this.defaultValues.refCity = '';
      this.defaultValues.tripType = this.tripTypes[0];
    },
    async showDetails(index) {
      try {
        this.selectedTrip = this.tripList[index];
        this.isOpenUpdate = true;
        this.showAddForm = false;
        const hasData = await this.$store.dispatch('tracking/show', {
          id: this.selectedTrip.trip_id,
        });
        if (hasData.error) {
          this.$error({ message: hasData.error });
        }
      } catch (error) {
        this.$error({ message: error });
      }
    },
    showTripForm() {
      this.isOpenUpdate = true;
      this.showAddForm = true;
    },
    async newTripAdd(data) {
      try {
        const result = await this.$store.dispatch('tracking/tripCreate', {
          data,
        });
        if (result.trip_id) {
          this.isOpenUpdate = false;
          this.$success({ message: 'Trip details added successfully' });
          this.$store.commit('tracking/SET_TRACK_PAGE', 1);
          this.loadmore();
        }
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (error) {
        this.$error({ message: 'APP_CATCH_ERR' });
      }
    },
    search(data) {
      const referenceCity = data.referenceCity ? { value: data.referenceCity, type: 'String' } : null;
      this.filterParams = {
        status: data.status,
        referenceCity: data.referenceCity,
        tripType: data.tripType,
      };
      this.openSlideleft = false;
      this.$store.commit('tracking/SET_TRACK_PAGE', 1);
      this.loadmore();
    },
    searchQuery(data) {
      this.queryTerms = {
        source: data.source,
        destination: data.destination,
        truck_number: data.truck_number,
        customer_reference: data.customer_reference,
      };
      this.$store.commit('tracking/SET_TRACK_PAGE', 1);
      this.loadmore();
    },
    constructParams() {
      const result = {};
      const dataKeys = Object.keys(this.queryTerms);
      const data = this.queryTerms;
      dataKeys.forEach((key) => {
        if (data[key] !== null) {
          result[key] = data[key];
        }
      });
      if (this.filterParams.status) {
        result.status = this.filterParams.status.id;
      }
      if (this.filterParams.tripType && this.filterParams.tripType.id) {
        result.haltedTrips = this.filterParams.tripType.value;
      }
      if (this.tripFilter.page) {
        result.page = this.tripFilter.page;
      }
      if (this.filterParams.referenceCity) {
        result.referenceCity = this.filterParams.referenceCity.name;
      }
      return result;
    },
    async loadmore() {
      try {
        const params = this.constructParams();
        const hasData = await this.$store.dispatch('tracking/tracklist', {
          params,
        });
        const trackMeta = await this.$store.dispatch('tracking/getTrackMeta');

        if (hasData.error) {
          this.$error({ message: hasData.error });
        }
        if (trackMeta.error) {
          this.$error({ message: trackMeta.error });
        }

        this.loadCheck = this.hasEmpty;
      } catch (error) {
        this.$error({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    async endTrip() {
      try {
        const result = await this.$store.dispatch('tracking/endTrip', {
          id: this.selectedTrip.trip_id,
        });
        if (result.trip_id) {
          this.selectedTrip = result;
          this.$success({ message: 'Trip ended successfully' });
        }
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (err) {
        this.$error({ message: err });
      }
    },
  },
};
</script>
